import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "paper-action-bar" }
const _hoisted_2 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_3 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_4 = { class: "tool-bar" }
const _hoisted_5 = { class: "tips-box" }
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = { style: {"height":"500px","flex":"auto"} }

import { computed, createVNode, reactive, ref, watch } from 'vue';
import { useFullscreen } from '../../../../hooks/fullscreen';
import {
  OioButton,
  OioInput,
  OioTag,
  OioSpin,
  OioPagination,
  OioForm,
  OioFormItem,
  OioCol,
  OioRow,
  OioMessage
} from '@kunlun/vue-ui-antd';
import { ExclamationCircleOutlined, FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import { exportExcelFile } from '../../../../utils/excel';
import { queryGoodsData, quicklyAdd } from './services';
import {getImportTemplateUrl, queryWorkbook} from "@/custom-widget/MindMap/api";
import XLSX from "xlsx";
interface IProps {
  renderActionVNodes: () => any;
  value: any[];
  change: (val: any) => any;
  reloadDataSource: (val: any) => any;
  orderPreview: (dataSource: any[]) => any;
  rModel: any;
  formData: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PaperProductsStraightShops',
  props: {
    renderActionVNodes: null,
    value: null,
    change: null,
    reloadDataSource: null,
    orderPreview: null,
    rModel: null,
    formData: null
  },
  setup(__props: any) {

const props = __props as { renderActionVNodes: () => any, value: any[], change: (val: any) => any, reloadDataSource: (val: any) => any, orderPreview: (dataSource: any[]) => any, rModel: any, formData: any }

const priceTypeEnumList = {
  EX_FACTORY_PRICE: '出厂价',
  PRICE: '一口价',
  REAL_PRICE: '实价',
  RETAIL_PRICE: '零售价'
};
const paperTypeEnumList = {
  COPY: '复印纸',
  PRINT: '打印纸'
};

const contentRef = ref<HTMLElement | undefined>();
const paperGoods = ref<any>();
const popupTableRef = ref<any>();
const { isFullscreen, toggleFullscreen } = useFullscreen(contentRef);
const searchStr = ref<string>('');
const searchVal = ref<string>('');
const tips = ref<string>('');
const addLoading = ref<boolean>(false);
const exportLoading = ref<boolean>(false);
const tableLoading = ref<boolean>(false);
const currentTableData = ref<any[]>([]);
const maskTableData = ref<any[]>([]);
const goodspopupShow = ref<boolean>(false);
const popupTableLoading = ref<boolean>(false);
const downloadLoading = ref(false);
const importLoading = ref(false);
const popupPagination = reactive<{ current: number; pageSize: number; total: number }>({
  current: 1,
  pageSize: 15,
  total: 0
});
const popupOnChange = async (page: number, pageSize: number) => {
  popupPagination.current = page;
  popupPagination.pageSize = pageSize;
  await queryGoodsDataApi();
};
const chooseGoods = (e: any) => {};

const searchData = reactive<{ code: string; name: string; itemNumber: string; id: string }>({
  code: '',
  name: '',
  itemNumber: '',
  id: ''
});
const autoFilterData = computed(() => {
  if (searchStr.value) {
    return props.value.filter((item) => (item.itemNumber + item.name + item.code).toString().includes(searchStr.value));
  } else {
    return props.value;
  }
});
watch(
  () => autoFilterData.value,
  () => {
    tableLoading.value = true;
    addLoading.value = true;
    currentTableData.value = [...autoFilterData.value];
    tableLoading.value = false;
    addLoading.value = false;
  }
);
const searchTableData = async () => {
  try {
    popupPagination.current = 1;
    searchTableDataLoading.value = true;
    await queryGoodsDataApi();
  } finally {
    searchTableDataLoading.value = false;
  }
};
const searchTableDataLoading = ref<boolean>(false);
const checkedGoods = async () => {
  const $table = popupTableRef.value;
  if ($table) {
    const records = $table.getCheckboxRecords();
    currentTableData.value = [...currentTableData.value, ...records];
  }
  await props.change(currentTableData.value);
  await props.reloadDataSource(currentTableData.value);
  goodspopupShow.value = false;
};

// 重新获取页面数据
const orderPreview = async () => {

  const res = await props.orderPreview(props.formData);
  currentTableData.value = res?.pcItemDetail || [];
  await props.change(currentTableData.value);
  await props.reloadDataSource(currentTableData.value);

};

const queryData = async (key: string) => {
  if (!key) return;
  const currentKey = key
      .split(' ');
  await currentKey?.forEach((e)=>{
    const ckey = e.split('\t');
    quicklyAddApi({ code: ckey[0], orderNum: ckey[1] ?? 0 });
  });
  //await quicklyAddApi({ code: currentKey[0], orderNum: currentKey[1] ?? 0 });
};
const quicklyAddApi = async (data: { code: string; orderNum: number }) => {
  try {
    addLoading.value = true;
    tableLoading.value = true;
    const res = await quicklyAdd(props.rModel, { code: data.code, orderNum: data.orderNum, salesOrganizationCode:props.formData.salesOrganization.code, relationApplyId:props.formData.relationApply.id, buyerPartnerId:props.formData.targetPartner.id });
    if (res.length === 0) {
      tips.value = '未查询到该商品';
    } else {
      const hasItem = currentTableData.value.filter((item) => item.id === res[0].id);
      if (hasItem.length > 0) {
        tips.value = '该商品已存在';
      } else {
        res[0].orderNum = Number(data.orderNum);
        currentTableData.value.push(res[0]);
        await props.change(currentTableData.value);
        await props.reloadDataSource(currentTableData.value);
        tips.value = '';
      }
    }
  } catch (error) {
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
  }
};
const checkedData = ref<any[]>([]);
const selectChangeEvent = ({ checked }) => {
  const $table = paperGoods.value;
  if ($table) {
    const records = $table.getCheckboxRecords();
    checkedData.value = records;
  }
};
//数组去重
const filterArrayByIds = (arrA: any[], arrB: any[]) => {
  const idsInB = new Set(arrB.map((item) => item.id));
  // 使用filter方法过滤arrayA，只保留那些id不在idsInB中的对象
  return arrA.filter((item) => !idsInB.has(item.id));
};

const openGoodsPopup = async () => {
  popupPagination.current = 1
  await queryGoodsDataApi();
  goodspopupShow.value = true;
};
const queryGoodsDataApi = async () => {
  try {
    if (!props.formData?.salesOrganization?.code) {
      OioMessage.error("请先选择销售办公室")
      throw "请先选择销售办公室"
    }
    addLoading.value = true
    popupTableLoading.value = true;
    searchData.id = currentTableData.value?.map((item) => item.id)?.join(',');
    const res = await queryGoodsData(props.rModel, {...searchData,salesOrganizationCode:props.formData.salesOrganization.code, relationApplyId:props.formData.relationApply.id, buyerPartnerId:props.formData.targetPartner.id}, {
      page: popupPagination.current,
      pageSize: popupPagination.pageSize
    });
    maskTableData.value = res.content;
    popupPagination.total = Number(res.totalElements);
  } finally {
    popupTableLoading.value = false;
    addLoading.value = false
  }
};
const delTableData = () => {
  Modal.confirm({
    title: '确认删除吗?',
    icon: createVNode(ExclamationCircleOutlined),
    async onOk() {
      try {
        tableLoading.value = true;
        const currentData = filterArrayByIds(currentTableData.value, checkedData.value);
        await props.change(currentData);
        await props.reloadDataSource(currentData);
        checkedData.value = [];
      } finally {
        tableLoading.value = false;
      }
    }
  });
};
const timer = ref<any>(null);
const changeTableData = async () => {
  
  try {
    addLoading.value = true;
    tableLoading.value = true;
    if (timer.value) {
      clearTimeout(timer.value);
    }
    timer.value = setTimeout(async () => {
      await props.change(currentTableData.value);
      await orderPreview();
    }, 200);
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
  }
};
const exportDataEvent = () => {
  try {
    exportLoading.value = true;
    const fileData = checkedData.value.map((i, index) => ({
      行号: index + 1,
      物料组: i.deliMaterialGroup.name,
      商品编码: i.code,
      商品名称: i.name,
      商品ERP编码: i.outCode,
      货号: i.itemNumber,
      '69码': i.barCode,
      价格类型: priceTypeEnumList[i.priceType],
      下单数量: i.orderNum,
      直发起订数量: i.startOrderNum,
      直发起订包装: i.startOrderUnit.name,
      实际下单数量: i.actualShipmentNum
    }));
    exportExcelFile(fileData, { filename: `纸品直发需求单商品明细${Date.now()}.xlsx` });
  } finally {
    exportLoading.value = false;
  }
};
const importDataEvent = () => {
  // 弹出选择文件弹窗
  const input = document.createElement('input');
  input.type = 'file';
  input.style.display = 'none';
  // sheet_to_array的实现
  function parseExcelSheetToArrays(sheet) {
    const Range = {
      x1: sheet['!ref'].split(':')[0].match(/^[A-Z]+/)[0],
      y1: sheet['!ref'].split(':')[0].match(/\d+$/)[0],
      x2: sheet['!ref'].split(':')[1].match(/^[A-Z]+/)[0],
      y2: sheet['!ref'].split(':')[1].match(/\d+$/)[0]
    };

    const tableDataArr: any = [];
    for (let y = Range.y1; y <= Range.y2; y++) {
      // 行遍历
      const rowArr: any[] = [];
      for (let x = Range.x1.charCodeAt(); x <= Range.x2.charCodeAt(); x++) {
        // 列遍历 TD:暂时只支持到A~Z列，有需要的自己优化
        const position = String.fromCharCode(x) + y;
        // @ts-ignore
        rowArr.push(sheet?.[position]?.v ?? null);
      }
      tableDataArr.push(rowArr);
    }

    // 移除表头
    tableDataArr.shift();

    // 过滤空行
    return tableDataArr.filter((row) => row.some((cell) => cell !== null));
  }

  const handleChangeFile = (e) => {
    const file = <File>e.target.files[0];
    const format = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
    const importFileFormat = ['xlsx', 'xls'];
    if (!importFileFormat.includes(format)) {
      OioMessage.error('仅支持上传excel文件');
    } else {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary', cellDates: true });
          const sheetNames = workbook.SheetNames;
          const worksheet = workbook.Sheets[sheetNames[0]];
          const arr = parseExcelSheetToArrays(worksheet);
          let str = '';
          arr.forEach((row, rowIndex) => {
           // str += `${rowIndex}\t`;

            row.forEach((col, colIndex) => {
              if (colIndex !== row.length - 1) {
                str += `${col}\t`;
              } else {
                str += `${col} `;
              }
            });
          });
          str = str.trimEnd();
          importLoading.value = true;
          tableLoading.value = true;
          await queryData(str, true);
        } finally {
          importLoading.value = false;
          tableLoading.value = false;
        }
      };
      reader.readAsBinaryString(file);
    }
    // 需要清除input的value，不然相同的文件无法上传多次
    if (input.value) {
      input.value = '';
    }
  };

  input.onchange = handleChangeFile;
  input.click();
};

const handleDownload = async () => {
  try {
    downloadLoading.value = true;
    const res = await queryWorkbook({
      ...props.rModel,
      model: 'deli.aries.seller.DeliAriesSellerPaperItem'
    });
    let id: any = res.content?.filter(item => item.displayName === '纸品直发商品导入模板')?.[0]?.id;
    const res1 = await getImportTemplateUrl(props.rModel, id);
    window.open(res1.redirectUri);
  } finally {
    downloadLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "paper-container",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: handleDownload,
          loading: downloadLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("下载模版")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: importDataEvent,
          loading: importLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("导入")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          disabled: checkedData.value.length === 0,
          onClick: exportDataEvent,
          loading: exportLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出")
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: openGoodsPopup,
          loading: addLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          disabled: checkedData.value.length === 0,
          onClick: delTableData,
          loading: exportLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("删除")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(OioInput), {
          value: searchStr.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchStr).value = $event)),
          placeholder: "按货号、商品名称、商品编码搜索",
          style: {"width":"220px"},
          "allow-clear": ""
        }, null, 8, ["value"]),
        _createElementVNode("span", {
          style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
        }, [
          (!_unref(isFullscreen))
            ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
            : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(OioInput), {
        value: searchVal.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchVal).value = $event)),
        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (queryData(searchVal.value)), ["enter"])),
        placeholder: "请粘贴商品编码 下单数量",
        style: {"width":"340px"}
      }, null, 8, ["value"]),
      _createVNode(_unref(OioButton), {
        type: "primary",
        loading: addLoading.value,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (queryData(searchVal.value)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("快速添加")
        ]),
        _: 1
      }, 8, ["loading"]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(ExclamationCircleOutlined), { style: {"font-size":"16px","color":"var(--oio-error-color)"} }),
        _createElementVNode("span", _hoisted_6, _toDisplayString(tips.value), 1)
      ], 512), [
        [_vShow, tips.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_vxe_table, {
        "header-align": "center",
        border: "",
        "scroll-x": { enabled: false },
        "scroll-y": { enabled: true, gt: 0, oSize: 20 },
        "row-config": { height: 80 },
        "column-config": { resizable: true },
        data: currentTableData.value,
        height: "auto",
        "keep-source": "",
        ref_key: "paperGoods",
        ref: paperGoods,
        "edit-config": { trigger: 'click', mode: 'cell' },
        loading: tableLoading.value,
        onCheckboxAll: selectChangeEvent,
        onCheckboxChange: selectChangeEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_column, {
            type: "checkbox",
            fixed: "left",
            width: "50"
          }),
          _createVNode(_component_vxe_column, {
            field: "deliMaterialGroup",
            title: "物料组",
            width: "120",
            "show-overflow": ""
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.deliMaterialGroup.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "code",
            title: "商品编码",
            width: "180",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "name",
            title: "商品名称",
            width: "120",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "outCode",
            title: "商品ERP编码",
            width: "100",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "itemNumber",
            title: "货号",
            width: "100",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "barCode",
            title: "69码",
            width: "160",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "subBrand",
            title: "子品牌",
            width: "160",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "paperType",
            title: "纸品类型",
            width: "160",
            "show-overflow": ""
          }, {
            default: _withCtx(({ row }) => [
              (paperTypeEnumList[row.paperType])
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(paperTypeEnumList[row.paperType]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "factoryPrice",
            title: "出厂价/件",
            width: "160",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "discountRate",
            title: "让利系数",
            width: "160",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "priceType",
            title: "价格类型",
            width: "100"
          }, {
            default: _withCtx(({ row }) => [
              (priceTypeEnumList[row.priceType])
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(priceTypeEnumList[row.priceType]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "lineTotalItemWeight",
            title: "商品重量",
            width: "100"
          }),
          _createVNode(_component_vxe_column, {
            field: "minPalletNum",
            title: "最小托盘数",
            width: "100"
          }),
          _createVNode(_component_vxe_column, {
            title: "下单数量",
            width: "150",
            field: "orderNum",
            "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
          }, {
            edit: _withCtx(({ row }) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: row.orderNum,
                "onUpdate:value": ($event: any) => ((row.orderNum) = $event),
                min: row.startOrderNum,
                step: 1,
                style: {"width":"110px"},
                onChange: changeTableData,
                onKeyup: _withKeys(changeTableData, ["enter"]),
                controls: true
              }, null, 8, ["value", "onUpdate:value", "min", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "startOrderNum",
            title: "直发起订数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "startOrderUnit",
            title: "直发起订包装",
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.startOrderUnit.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "actualShipmentNum",
            title: "实际下单数量",
            width: "200"
          }),
          _createVNode(_component_vxe_column, {
            field: "originalOrderNum",
            title: "原始下单数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "suggestedOrderNum",
            title: "SRM建议下单数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "actualReceivedNum",
            title: "到货无异常数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "qualityExceptionQuantity",
            title: "破损可接受数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "transportDamageQuantity",
            title: "拒收数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "salesOrderNumGenerated",
            title: "已生成销售单数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "salesOrderNumNeedGenerated",
            title: "待生成销售单数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "requiredNum",
            title: "要货数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "applyNum",
            title: "申报数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "loadingNum",
            title: "装车数量",
            "min-width": "120"
          })
        ]),
        _: 1
      }, 8, ["data", "loading"])
    ]),
    _createVNode(_component_a_modal, {
      class: "oio-modal",
      visible: goodspopupShow.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((goodspopupShow).value = $event)),
      title: "添加",
      onOk: checkedGoods,
      width: 1000
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          data: searchData,
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "商品编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: searchData.code,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchData.code) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "商品名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: searchData.name,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchData.name) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "货号" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: searchData.itemNumber,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchData.itemNumber) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioButton), {
                      type: "primary",
                      onClick: searchTableData,
                      loading: searchTableDataLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_unref(OioSpin), { loading: tableLoading.value }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_table, {
              border: "",
              ref_key: "popupTableRef",
              ref: popupTableRef,
              "max-height": "400",
              "keep-source": "",
              "column-config": { resizable: true },
              data: maskTableData.value,
              onCheckboxChange: chooseGoods,
              onCheckboxAll: chooseGoods,
              loading: popupTableLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliMaterialGroup",
                  title: "物料组",
                  width: "120",
                  "show-overflow": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row?.deliMaterialGroup?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "brand",
                  title: "品牌",
                  width: "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row?.brand?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "code",
                  title: "商品编码",
                  width: "180",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "name",
                  title: "商品名称",
                  width: "120",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "outCode",
                  title: "商品ERP编码",
                  width: "100",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNumber",
                  title: "货号",
                  width: "100",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "barCode",
                  title: "69码",
                  width: "160",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "subBrand",
                  title: "子品牌",
                  width: "160",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "paperType",
                  title: "纸品类型",
                  width: "160",
                  "show-overflow": ""
                }, {
                  default: _withCtx(({ row }) => [
                    (paperTypeEnumList[row.paperType])
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 0,
                          bordered: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(paperTypeEnumList[row.paperType]), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "factoryPrice",
                  title: "出厂价/件",
                  width: "160",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "discountRate",
                  title: "让利系数",
                  width: "160",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "priceType",
                  title: "价格类型",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    (priceTypeEnumList[row.priceType])
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 0,
                          bordered: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(priceTypeEnumList[row.priceType]), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "minPalletNum",
                  title: "最小托盘数",
                  "min-width": "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "startOrderNum",
                  title: "直发起订数量",
                  "min-width": "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "startOrderUnit",
                  title: "直发起订包装",
                  "min-width": "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row?.startOrderUnit?.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "loading"]),
            _createVNode(_unref(OioPagination), {
              style: {"margin-top":"12px"},
              current: popupPagination.current,
              "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((popupPagination.current) = $event)),
              "page-size": popupPagination.pageSize,
              "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((popupPagination.pageSize) = $event)),
              total: popupPagination.total,
              "show-total": (total) => `${total} 条`,
              "show-quick-jumper": "",
              onChange: popupOnChange
            }, null, 8, ["current", "page-size", "total", "show-total"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})